import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import * as actions from '../../actions';
import { StyledHeader } from './Header';
import { IStore } from '../../interfaces';
import AppRouter from './AppRouter';
import { useAppDispatch } from '../../utils/modules';

export const LinksContainer = styled.div`
	display: flex;
`;

export const ImageLinkContainer = styled.img`
	max-height: 15px;
	margin-right: 5px;
`;

const AppContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	background-color: black;
	color: white;
`;

export const HeaderContainer = styled.div`
	flex: 0 1 60px;
	display: flex;
	border-bottom: 1px solid #F89504
`;

export const ContentContainer = styled.div`
	display: flex;
	flex-direction: row;
	height: 100%;
	overflow: hidden;
	position: relative;
`;

interface IHomeStyledLink {
	isMobileViewActive: boolean;
}
export const HomeStyledLink = styled(StyledHeader)<IHomeStyledLink>`
	font-size: ${props => props.isMobileViewActive ? '14px' : '18px'};
`;

interface IPopUpContainerDiv {
	isMobileViewForPopUp: boolean;
}
export const PopUpContainerDiv = styled.div<IPopUpContainerDiv>`
	padding: 15px;	
	position: absolute;
	height: auto;
	min-height: 500px;
	max-width: 500px;
	width: 100%;
	top: calc(50% - 225px);
	left: ${props => props.isMobileViewForPopUp ? '0' : 'calc(50% - 250px)'};
	z-index: 51;
	display: flex;
	flex-direction: column;
	outline: none;
	transition: opacity ease-in-out .15s, opacity ease-in-out .15s;
	white-space: pre-line;
	background: url('../img/background/bck_theme.jpg') no-repeat center center;
	-webkit-background-size: cover;
	-moz-background-size: cover;
	-o-background-size: cover;
	background-size: cover;
	color: white;
	box-sizing: border-box;
	user-select: none;
	i {
		color: white;
	}
`;

export const PopUpIcon = styled.i`
	cursor: pointer;
`;

export default function App() {

	const dispatch = useAppDispatch();

	useEffect(() => {
		dispatch(actions.init());
		dispatch(actions.getBasicData());
		dispatch(actions.updateViewPort(window.innerWidth, window.innerHeight));
	}, [dispatch]);

	const updateViewPort = useCallback(
		() => {
			dispatch(actions.updateViewPort(window.innerWidth, window.innerHeight));
		},
		[dispatch]
	);

	useEffect(() => {
		window.addEventListener('resize', updateViewPort);
	}, [dispatch, updateViewPort]);


	const isMobileViewActive = useSelector(
		(completeState: IStore): boolean => {
			return !!completeState?.ui?.isMobileViewActive;
		});

	const showTreeMap = useSelector(
		(completeState: IStore): boolean => {
			return !!completeState?.ui?.showTreeMap;
		});

	return (
		<AppContainer>
			<AppRouter
				shouldRenderTreeMap={!isMobileViewActive ? true : showTreeMap}
				isMobileViewActive={isMobileViewActive}
			/>
		</AppContainer>
	);
}
